import { gql } from '@apollo/client';
import { lineItemDetailsForInvoiceInPPC } from './fetch-coupled-line-items-in-ppc';

export const Overage = gql`
  ${lineItemDetailsForInvoiceInPPC}
  fragment Overage on InvoiceLineItems {
    overage {
      totalAccruedSubtotal
      totalUsersAdded
      totalTaxApplied
      totalMarginsApplied
      totalDiscountsApplied
      taxItems {
        id
        taxPercent
        tax
        taxId
        taxAmountLabel
        taxIdLabel
      }
      lineItems {
        ...lineItemDetailsForInvoiceInPPC
      }
    }
  }
`;
